import { gql } from '@apollo/client';

export const queryUsDrawbackClaim = gql`
  query GetUsDrawbackClaim($id: ID!) {
    usDrawbackClaim(id: $id) {
      id
      version
      status
      deadline
      brokerNumber
      entryNumber
      drawbackProvision
      drawbackFilingPortCode
      cbpStatus
      cbpRejectionReasons {
        code
        name
      }
      oneTimeWaiverIndicator
      waiverPriorNotice
      claimant {
        type
        value
      }
      operator {
        id
        name
      }
      created {
        time
        client {
          id
          name
        }
      }
      updated {
        time
        client {
          id
          name
        }
      }
      canceled {
        reason {
          text
        }
      }
      tags {
        key
        value
      }
      confirmations {
        id
        status
      }
      inquiries {
        reasonCodes
        description
        milestone {
          id
        }
        task {
          id
        }
      }
      group {
        id
        shipment {
          id
          friendlyId
          clientReferences {
            bookingId
            fbaShipmentId
          }
        }
        shipper {
          id
        }
        forwarders {
          forwarder {
            id
          }
        }
      }
      tasks {
        id
        version
        name
        status
        deadline
        assignee {
          id
          name
        }
        assignmentTeam {
          name
          id
        }
        definition {
          id
          workOrderTaskType
        }
        steps {
          id
          name
          description
          completed {
            time
          }
          isFinalConfirmation
        }
        completed {
          time
        }
        deleted {
          time
        }
      }
      milestones {
        id
        name
        occurenceTime
        source
        tags {
          key
          value
        }
        created {
          client {
            name
          }
        }
      }
      documents {
        id
        tags {
          key
          value
        }
      }
      drawbackClaimReference {
        downloadLink
        referenceKey
      }
      matchPairs {
        assignmentStatus
        clientReference
        matchedQuantity
        import {
          actionIndicator
          cbpEntrySummaryLineNumber
          classifications {
            htsNumber
            articleDescriptionText
            quantities {
              quantity
              allowableQuantity
              enteredValuePerUnit
              substitutedValuePerUnit
              subsitutedValuePerUnit
              unitOfMeasureCode
            }
          }
          drawbackAccountingMethodCode
          entryNumber
          importTrackingIdentificationNumber
          revenuesClaimed {
            accountingClassCode
            calculatedAmount
            claimAmount
          }
        }
        export {
          exportDestroyIndicator
          htsNumber
          articleDescriptionText
          countryOfUltimateDestination
          exportDestroyDate
          nameOfExporterDestroyer
          quantity
          unitOfMeasureCode
          unitValue
          uniqueIdentifierNumber
          importTrackingIdentificationNumbers
        }
      }
      imports {
        actionIndicator
        cbpEntrySummaryLineNumber
        classifications {
          htsNumber
          articleDescriptionText
          quantities {
            quantity
            allowableQuantity
            enteredValuePerUnit
            substitutedValuePerUnit
            subsitutedValuePerUnit
            unitOfMeasureCode
          }
        }
        drawbackAccountingMethodCode
        entryNumber
        importTrackingIdentificationNumber
        revenuesClaimed {
          accountingClassCode
          calculatedAmount
          claimAmount
        }
      }
      TFTEAExportDestroyArticles {
        htsNumber
        articleDescriptionText
        countryOfUltimateDestination
        exportDestroyDate
        nameOfExporterDestroyer
        quantity
        unitValue
        uniqueIdentifierNumber
        importTrackingIdentificationNumbers
      }
    }
  }
`;

export const updateUsDrawbackClaim = gql`
  mutation UpdateUsDrawbackClaim(
    $id: ID!
    $version: Int!
    $input: UpdateUsDrawbackClaimInput!
  ) {
    updateUsDrawbackClaim(id: $id, version: $version, input: $input) {
      record {
        id
        version
      }
    }
  }
`;

export const createUsDrawbackClaimCbpMutation = gql`
  mutation CreateUsDrawbackClaimCbp(
    $idempotencyKey: String!
    $usDrawbackClaimId: ID!
  ) {
    createUsDrawbackClaimCbp(
      idempotencyKey: $idempotencyKey
      usDrawbackClaimId: $usDrawbackClaimId
    ) {
      transaction {
        id
        version
      }
    }
  }
`;

export const validateUsDrawbackClaimCbpQuery = gql`
  query ValidateUsDrawbackClaimCbp($id: ID!) {
    validateUsDrawbackClaimCbp(idInput: { id: $id }) {
      errors {
        field
        message
      }
      warnings {
        message
        type
      }
    }
  }
`;
